import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const AllCreatives = lazy(() => import("../pages/creative-listing"));
const UploadCreative = lazy(() => import("../pages/upload-creative"));
const CreativePreview = lazy(() => import("../pages/creative-preview"));
const CreativeSearch = lazy(() => import("../pages/creative-search"));
const Default = lazy(() => import("../../../../layouts/dashboard/default"));
const MyContent = lazy(() => import("../pages/my-content"));

export const CreativeLibraryRouter = [
  {
    path: "creative-library",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "listing",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllCreatives />
          </Suspense>
        ),
      },

      {
        path: "upload",
        element: (
          <Suspense fallback={<Backdrop />}>
            <UploadCreative />
          </Suspense>
        ),
      },
      {
        path: "preview",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreativePreview />
          </Suspense>
        ),
      },
      {
        path: "search",
        element: (
          <Suspense fallback={<Backdrop />}>
            <CreativeSearch />
          </Suspense>
        ),
      },
      {
        path: "my-content",
        element: (
          <Suspense fallback={<Backdrop />}>
            <MyContent />,
          </Suspense>
        ),
      },
    ],
  },
];
